import { jsx as o, jsxs as v, Fragment as T } from "react/jsx-runtime";
import B, { useState as U, useEffect as W } from "react";
import { u as a } from "./index-6a632112.mjs";
import { s as i, d as $, Q as d, r, B as c } from "./themes-5f0b3c3d.mjs";
import { t as n } from "./textStyles-42cab346.mjs";
import { S as z } from "./playFilled-b880efda.mjs";
import { IconButton as I } from "./iconButton.js";
import { MediaDisclosureButton as D } from "./mediaDisclosureButton.js";
import { useWindowDimensions as O } from "./useWindowDimensions.js";
import "./lineHeights-72d3110c.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./types-b577bf77.mjs";
import "./button.js";
import "./accessibility.js";
import "./zIndices-d07533f3.mjs";
const m = "218px", h = "436px", s = "689px", _ = a.div`
  display: flex;
  flex-direction: column;
  max-width: 1224px;
  margin: ${i["8x"]} auto;
`, M = a.div`
  color: ${(e) => e.theme.components.blogVideo.headlineTextColor};
  font-size: ${n.headline.xl.fontSize};
  font-family: ${$.headline};
  font-weight: ${n.headline.xl.fontWeight};
  line-height: ${n.headline.xl.lineHeight};
`, G = a.div`
  margin-top: ${i["4x"]};
  color: ${(e) => e.theme.components.blogVideo.subheadlineTextColor};
  font-size: ${n.headline.m.fontSize};
  font-family: ${$.headline};
  font-weight: ${n.headline.m.fontWeight};
  line-height: ${n.headline.m.lineHeight};

  @media ${d.tabletAndUp} {
    margin-top: ${i["12x"]};
  }
`, j = a.div`
  margin-top: ${i["2x"]};
  color: ${(e) => e.theme.components.blogVideo.bodyTextColor};
  font-size: ${n.body.regular.m.fontSize};
  font-family: ${$.body};
  font-weight: ${n.body.regular.m.fontWeight};
  line-height: ${n.body.regular.m.lineHeight};
`, L = a.div`
  margin-top: ${i["4x"]};
  position: relative;
  background: ${(e) => e.theme.components.blogVideo.videoPlaceholderBackgroundColor};
  border-radius: ${r["1x"]};
  max-height: ${m};
  min-height: ${m};
  height: ${m};

  iframe {
    border-radius: ${r["1x"]};
  }

  @media ${d.tabletAndUp} {
    margin-top: ${i["6x"]};
    border-radius: ${r["2x"]};
    min-width: 300px;
    height: ${h};
    max-height: ${h};

    iframe {
      border-radius: ${r["2x"]};
    }
  }

  @media ${d.laptopAndUp} {
    height: ${s};
    max-height: ${s};
  }
`, R = a.img`
  background: ${(e) => e.theme.components.blogVideo.videoPlaceholderBackgroundColor};
  position: absolute;
  border-radius: ${r["1x"]};
  cursor: pointer;
  max-width: 100%;
  width: 100%;
  height: ${m};
  object-fit: cover;

  @media ${d.tabletAndUp} {
    border-radius: ${r["2x"]};
    height: ${h};
    max-height: ${h};
  }

  @media ${d.laptopAndUp} {
    height: ${s};
    max-height: ${s};
  }
`, F = a(I)`
  && {
    position: absolute;
    left: ${i["8x"]};
    bottom: ${i["6x"]};
    z-index: 2;

    @media ${d.tabletAndUp} {
      left: ${i["10x"]};
      bottom: ${i["8x"]};
    }
  }
`, N = a.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
  border-radius: ${r["1x"]};
  cursor: pointer;

  background: linear-gradient(
    180deg,
    ${(e) => e.theme.components.blogVideo.gradientOverlayStartColor}
      15.29%,
    ${(e) => e.theme.components.blogVideo.gradientOverlayEndColor} 100%
  );

  @media ${d.tabletAndUp} {
    border-radius: ${r["2x"]};
  }
`;
function Q({ children: e, ...t }) {
  return /* @__PURE__ */ o(M, { ...t, children: e });
}
function K({ children: e, ...t }) {
  return /* @__PURE__ */ o(G, { ...t, children: e });
}
function q({ children: e, ...t }) {
  return /* @__PURE__ */ o(j, { ...t, children: e });
}
function J({
  shouldShowGradientOverlay: e = !0,
  coverImage: t,
  onClick: C,
  children: S,
  playButtonSize: w = "medium",
  disclosureLinks: x,
  accessibilityOptions: H = { ariaLabel: "Play" },
  ...A
}) {
  const [f, E] = B.useState(
    !!t
  ), [V, k] = B.useState(!0), b = {
    right: ["108px", "108px", "20px"],
    bottom: ["25px", "14px", "8px"]
  };
  function g(P) {
    C?.(P), E(!1), k(!1);
  }
  const [y, u] = U(0), { width: p } = O();
  return W(() => {
    p > c.laptopMin ? u(0) : p < c.laptopMin && p > c.tabletMin ? u(1) : u(2);
  }, [p]), /* @__PURE__ */ v(L, { ...A, children: [
    f && /* @__PURE__ */ v(T, { children: [
      /* @__PURE__ */ o(
        F,
        {
          accessibilityOptions: H,
          icon: /* @__PURE__ */ o(z, { "aria-hidden": !0 }),
          onClick: g,
          size: w
        }
      ),
      e && /* @__PURE__ */ o(N, { "aria-hidden": "true", onClick: g }),
      /* @__PURE__ */ o(
        R,
        {
          "aria-hidden": "true",
          src: t,
          onClick: g
        }
      )
    ] }),
    x && V && /* @__PURE__ */ o(
      D,
      {
        ...x,
        alignment: "bottom-right",
        containerPosition: {
          bottom: b.bottom[y],
          right: b.right[y]
        }
      }
    ),
    /* @__PURE__ */ o("div", { "aria-hidden": f ? "true" : "false", children: S })
  ] });
}
function l({ children: e, ...t }) {
  return /* @__PURE__ */ o(_, { ...t, children: e });
}
l.Headline = Q;
l.Subheadline = K;
l.Body = q;
l.VideoContainer = J;
l.mobileHeight = m;
l.tabletHeight = h;
l.laptopAndUpHeight = s;
export {
  l as BlogVideo
};
